import type { FC, ReactNode } from "react";

import styled from "styled-components";

import {
    FlexRow,
    DurationSelectorGranularitySwitch,
    CircleSwitherStyled,
    EGranularity,
} from "@similarweb/ui-components";

const DurationSelectorGranularitySwitchContainer = styled(FlexRow)`
    justify-content: center;
    ${CircleSwitherStyled} {
        margin-right: 0px;
        button {
            width: 152px;
            height: 40px;
        }
    }
`;

interface IGranularitySwitchProps {
    weeklyToggleProps?: {
        weekly?: ReactNode;
        monthly?: ReactNode;
    };
    onGranularityToggleClick?: (granularity: EGranularity) => void;
}
export const GranularitySwitch: FC<IGranularitySwitchProps> = ({ weeklyToggleProps, onGranularityToggleClick }) => {
    return (
        <DurationSelectorGranularitySwitchContainer>
            <DurationSelectorGranularitySwitch
                selectedGranularity={EGranularity.MONTHLY}
                // @ts-ignore FIXME: strict migration - Type '((granularity: EGranularity) => void) | undefined' is not assignable to type '(granularity: EGranularity) => void' — onGranularityToggleClick is an optional prop, external DurationSelectorGranularitySwitch requires it
                onGranularityToggleClick={onGranularityToggleClick}
                weeklyLabel={weeklyToggleProps?.weekly}
                monthlyLabel={weeklyToggleProps?.monthly}
                dailyLabel={null}
            />
        </DurationSelectorGranularitySwitchContainer>
    );
};
